module.exports = __webpack_public_path__ + "img/flow.0c557a9e.png";